import { themeAtom } from "../../shared/atoms";
import { CancelConfirmationProps } from "../models/CancelConfirmationMessage.model";
import { ReusableButton } from "./ReusableTableButton";
import { useAtomValue } from "jotai";
import React from "react";
import ReactDOM from "react-dom";
import { twMerge } from "tailwind-merge";

const CancelConfirmation: React.FC<CancelConfirmationProps> = ({ message, onClickYes, onClickNo }) => {
  const theme = useAtomValue(themeAtom);

  return ReactDOM.createPortal(
    <div
      className={twMerge(
        "fixed inset-0 z-50 flex items-center justify-center border backdrop-blur-sm",
        `${theme.home.tailwind.backgound}/50`,
      )}
      onClick={onClickNo}
    >
      <div
        id="alert-box"
        className={twMerge(
          "z-50 flex h-[150px] w-[350px] flex-col justify-between rounded-xl border px-4 py-4 shadow-xl",
          theme.uwhcAssistant.tableBg,
          theme.uwhcAssistant.border,
          theme.home.tailwind.textDefault,
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ml-4 mt-4 text-left text-[14px]">{message}</div>

        <div className="flex justify-end">
          <ReusableButton width={60} buttonText="Yes" onClickHandler={onClickYes} className="mb-2" />
          <ReusableButton width={60} buttonText="No" onClickHandler={onClickNo} className="mb-2 ml-3 mr-3" />
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default CancelConfirmation;
